import React from 'react';
import FakeIconTextGroup from '@/components/Fakes/FakeIconTextGroup';
// import Card, { CARD_COLOR } from '@gerenciatd/next.components.card-n';
import styles from '../styles';

export const COMPONENT_NAME = 'ThreatsCardFake';

const ThreatsCardFake = ({ numItems }) => {
  const array = Array.from({ length: numItems }, (v, i) => i);
  return (
    <div className="row treats-card-fake">
      {/* <Card className="col-sm-12 col-xs-12" borderColor={CARD_COLOR.GREY_3}> */}
        {array.map((item) => (
          <FakeIconTextGroup key={`${COMPONENT_NAME} ${item}`} />
        ))}
      {/* </Card> */}
      <style jsx>{styles}</style>
    </div>
  );
};
export default ThreatsCardFake;
